import Swal from 'sweetalert2';
import { Workbox } from 'workbox-window';

var wb;

self.addEventListener('load', () => {
    // Is service worker available?
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker.js', {
            scope: "/",
        }).then((registration) => {

            registration.update().then(() => {
                if (registration?.waiting) {
                    self.dispatchEvent(new Event("waiting"));
                }
            });


        }).catch((error) => {
            console.warn('Error registering service worker:');
            console.warn(error);
        });
    }
});
self.addEventListener("waiting", () => {

    wb = new Workbox('/service-worker.js');
    wb.addEventListener('controlling', () => {
        window.location.reload();
    });

    Swal.fire({
        icon: 'question',
        title: `Uma nova atualização está disponível`,
        text: 'Deseja instalar agora?',
        showDenyButton: true,
        confirmButtonText: "Sim",
        denyButtonText: `Não`,
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            wb.messageSkipWaiting();
        }
    });


    wb.register();
});

if ('serviceWorker' in navigator) {

    // navigator.serviceWorker.addEventListener("controlling", function () {
    //     prompt("entrei no controlling");
    //     window.location.reload();
    // });

    // navigator.serviceWorker.addEventListener("controllerchange", function () {
    //     prompt("entrei aqui controllerchange");
    //     window.location.reload();
    // });
}
